<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-input v-model="getYcToolsAiBaseList_data.ytabName" placeholder="请输入标题" clearable size='small'
                    style="max-width:200px;" />
                <el-select v-model='getYcToolsAiBaseList_data.ytabWordExport' clearable size='small'
                    placeholder="请选择支持导出word" style="max-width:200px;">
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                </el-select>
                <el-select v-model='getYcToolsAiBaseList_data.ytabStatus' clearable size='small' placeholder="请选择状态"
                    style="max-width:200px;">
                    <el-option label="未发布" :value="1"></el-option>
                    <el-option label="已发布" :value="2"></el-option>
                    <el-option label="已下架" :value="3"></el-option>
                </el-select>
                <!-- <el-select v-model='getYcToolsAiBaseList_data.mtmId' clearable placeholder="请输入分类" size='small'
                    style="max-width:200px;">
                    <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId"
                        :label="item.mtmName" :value="item.mtmId"></el-option>
                </el-select> -->
                <el-button @click="getData" type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if="addYcToolsAiBase" @click=" $form('addYcToolsAiBase')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加智能体工具
                </el-button>
            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getYcToolsAiBaseList' api='getYcToolsAiBaseList'
            xupdateapi='updateYcToolsAiBase' :height="H - 165">
            <icol slot='ytabIcon' :showtooltip='false' img='ytabIcon' />
        </mytable>
        <myform :viewobj='{
            updateYcToolsAiBaseCopyToOtherProject: ["复制智能体工具到其他项目", "el-icon-edit-outline"],
            $succeed$: getYcToolsAiBaseList
        }' @closed="$form('updateYcToolsAiBaseCopyToOtherProject', 'reset'), window.sleep(50, v => Myformdata && (Myformdata.ytabIcon = ''))
            ">
            <template v-slot:projectId="{ Myformdata }">
                <el-select v-model="Myformdata.projectId" clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
            </template>
            <hide slot='ytabId' />
        </myform>

        <myform :viewobj='{
            addYcToolsAiBase: ["新增智能体工具", "el-icon-circle-plus"],
            updateYcToolsAiBase: ["修改智能体工具", "el-icon-edit-outline"],
            $succeed$: getYcToolsAiBaseList
        }' @closed="$form('updateYcToolsAiBase', 'reset'), window.sleep(50, v => Myformdata && (Myformdata.ytabIcon = ''))
            " @confirm='myform'>
            <template v-slot:ytabBackgroundDes="{ Myformdata }">
                <el-input type="textarea" v-model="Myformdata.ytabBackgroundDes" style="width: 100%;"></el-input>
            </template>
            <template v-slot:ytabQuestionExample="{ Myformdata }">
                <el-input type="textarea" v-model="Myformdata.ytabQuestionExample" style="width: 100%;"></el-input>
            </template>
            <template v-slot:ytabWordExport="{ Myformdata }">
                <el-select v-model='Myformdata.ytabWordExport' clearable placeholder="请选择支持导出word"
                    style="max-width:200px;">
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                </el-select>
            </template>
            <template v-slot:yatbQuestionForm="{ Myformdata }">
                <el-select v-model='Myformdata.yatbQuestionForm' clearable placeholder="请选择" style="max-width:200px;">
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                </el-select>
            </template>
            <template v-slot:ytabStatus="{ Myformdata }">
                <el-select v-model='Myformdata.ytabStatus' clearable placeholder="请选择状态" style="max-width:200px;">
                    <el-option label="未发布" :value="1"></el-option>
                    <el-option label="已发布" :value="2"></el-option>
                    <el-option label="已下架" :value="3"></el-option>
                </el-select>
            </template>
            <template v-slot:ytabIcon='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.ytabIcon+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.ytabIcon = C : false )
                    `' @change='Myformdata.ytabIcon = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.ytabIcon = "")' type='image' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.ytabIcon && Myformdata.ytabIcon != ' '
                        ? ({ name: Myformdata.ytabIcon, url: Myformdata.ytabIcon })
                        : false"
                    :style="{ height: Myformdata.ytabIcon && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
                </myupload>
            </template>
            <hide slot='ytabId' />
        </myform>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mainType: [],
            ytabId: null,
            theytabId: "",
            getMicrolectureTypeMainList_data: [],
            tableColums_getYcToolsAiBaseList: {
                $selection: false,
                ytabName: '智能体工具标题',

                ytabAppId: '智能体工具id',
                ytabIcon: '图标',
                ytabBackgroundDes: '描述',
                ytabQuestionExample: '示例提示词',
                ytabWordExport: ['是否支持导出word', , '@v-if: 1:否#danger, 2:是#success'],
                ytabStatus: ['状态', , '@v-if: 1:未发布#danger, 2:已发布#success, 3:已下架#danger'],
                createtime: '创建时间',

                $operation: [
                    '操作', 300,
                    this.updateYcToolsAiBaseCopyToOtherProject && `@text: 复制到其他项目#primary
                    @click: $form("updateYcToolsAiBaseCopyToOtherProject",$row)
            `,
                    this.updateYcToolsAiBase && `@text: 编辑#warn
             @click: $form("updateYcToolsAiBase",$row)
            `,
                    this.deleteYcToolsAiBase && `@text: 删除#danger
             @click: _confirm('确定要删除吗?')
                     .trigger('deleteYcToolsAiBase',{ytabId:$row.ytabId})
                     .trigger('getYcToolsAiBaseList')
            `,
                    this.updateYcToolsAiBaseStatusUp && `@text: 上架#success
           @click: _confirm('确定要上架该场景吗?')
                   .trigger('updateYcToolsAiBaseStatusUp',{ytabId:$row.ytabId})
                   .trigger('getYcToolsAiBaseList')
          `,
                    this.updateYcToolsAiBaseStatusDown && `@text: 下架#danger
           @click: _confirm('确定要下架该场景吗?')
                   .trigger('updateYcToolsAiBaseStatusDown',{ytabId:$row.ytabId})
                   .trigger('getYcToolsAiBaseList')
          `,
                ],

            },

        };
    },

    watch: {

    },

    methods: {
        async myform(submit, Myformdata) {
            const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
        },
        async sub(submit) {
            this.$nextTick(() => {

            })
            submit();
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getYcToolsAiBaseList({
                ...this.getYcToolsAiBaseList_data,
                projectId: this.theProjectId
            })
        },
        getData() {
            this.getYcToolsAiBaseList({
                ...this.getYcToolsAiBaseList_data,
                projectId: this.theProjectId
            })
        }
    },

    async created() {
        //   this.getMicrolectureTypeMainLists().result((res) => {
        //     if (res.data.data) {
        //       console.log(res.data.data);
        //       this.getMicrolectureTypeMainList_data = res.data.data
        //     }
        //   }) 
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getYcToolsAiBaseList();
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/aiTools/aiToolsList.vue